export default __webpack_public_path__ + "static/media/arrow-down.bbe236cd.svg";